import Vue from 'vue';
import Router from 'vue-router';
import checkUpdate from '@/common/uploadVersion'
// import ssoLogin from '@/pages/ssologin';


Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/ssologin',
    //   name: 'ssoLogin',
    //   component: ssoLogin,
    // },
    {
      path: '/',
      redirect: {name: 'login'},
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/register'),
    },
    {
      path: '/home',
      component: () => import('@/pages/home'),
      children: [
        {
          path: '',
          redirect: {name: 'index'}
        },
        {
          path: '/welcome',
          name: 'welcome',
          component: () => import('@/pages/welcome'),
          meta: {path: '/welcome'}
        },
        {
          path: '/index',
          name: 'index',
          component: () => import('@/pages/index'),
          meta: {path: '/index'}
        },
        {
          path: '/lectureHall',
          name: 'lectureHall',
          component: () => import('@/pages/lectureHall'),
          meta: {path: '/lectureHall'}
        },
        {
          path: '/microCourses',
          name: 'microCourses',
          component: () => import('@/pages/microCourses'),
          meta: {path: '/microCourses'}
        },
        {
          path: '/microCoursesList',
          name: 'microCoursesList',
          component: () => import('@/pages/microCoursesList'),
          meta: {path: '/microCoursesList'}
        },
        {
          path: '/microCoursesAdd',
          name: 'microCoursesAdd',
          component: () => import('@/pages/microCoursesAdd'),
          meta: {path: '/microCoursesList'}
        },
        {
          path: '/microCoursesAudit',
          name: 'microCoursesAudit',
          component: () => import('@/pages/microCoursesAudit'),
          meta: {path: '/microCoursesAudit'}
        },
        {
          path: '/microCoursesDetail',
          name: 'microCoursesDetail',
          component: () => import('@/pages/microCoursesDetail'),
          meta: {path: '/microCoursesAudit'}
        },
        {
          path: '/detail',
          name: 'detail',
          component: () => import('@/pages/detail'),
          meta: {path: '/detail'}
        },
        {
          path: '/resource',
          name: 'resource',
          component: () => import('@/pages/resource'),
          meta: {path: '/resource'}
        },
        {
          path: '/resourceDetail',
          name: 'resourceDetail',
          component: () => import('@/pages/resourceDetail'),
          meta: {path: '/resource'}
        },
        {
          path: '/resourceTest',
          name: 'resourceTest',
          component: () => import('@/pages/resourceTest'),
          meta: {path: '/resource'}
        },
        {
          path: '/resourceExam',
          name: 'resourceExam',
          component: () => import('@/pages/resourceExam'),
          meta: {path: '/resource'}
        },
          {
          path: '/testResult',
          name: 'testResult',
          component: () => import('@/pages/testResult'),
          meta: {path: '/resource'}
        },
        {
          path: '/onlineExam',
          name: 'onlineExam',
          component: () => import('@/pages/onlineExam'),
          meta: {path: '/onlineExam'}
        },
        {
          path: '/onlineExamStages',
          name: 'onlineExamStages',
          component: () => import('@/pages/onlineExamStages'),
          meta: {path: '/onlineExam'}
        },
        {
          path: '/onlineExamStudy',
          name: 'onlineExamStudy',
          component: () => import('@/pages/onlineExamStudy'),
          meta: {path: '/onlineExam'}
        },
        {
          path: '/onlineExamExam',
          name: 'onlineExamExam',
          component: () => import('@/pages/onlineExamExam'),
          meta: {path: '/onlineExam'}
        },
        // {
        //   path: '/onlineExamExam2',
        //   name: 'onlineExamExam2',
        //   component: () => import('@/pages/onlineExamExam2'),
        //   meta: {path: '/onlineExam2'}
        // },
        {
          path: '/onlineExamResult',
          name: 'onlineExamResult',
          component: () => import('@/pages/onlineExamResult'),
          meta: {path: '/onlineExam'}
        },
        {
          path: '/teachManagement',
          name: 'teachManagement',
          component: () => import('@/pages/teachManagement'),
          meta: {path: '/teachManagement'}
        },
        {
          path: '/teachAdd',
          name: 'teachAdd',
          component: () => import('@/pages/teachAdd'),
          meta: {path: '/teachManagement'}
        },
        {
          path: '/teachDetail',
          name: 'teachDetail',
          component: () => import('@/pages/teachDetail'),
          meta: {path: '/teachManagement'}
        },
        {
          path: '/teachList',
          name: 'teachList',
          component: () => import('@/pages/teachList'),
          meta: {path: '/teachList'}
        },
        {
          path: '/wrongCollection',
          name: 'wrongCollection',
          component: () => import('@/pages/wrongCollection'),
          meta: {path: '/wrongCollection'}
        },
        {
          path: '/wrongDetail',
          name: 'wrongDetail',
          component: () => import('@/pages/wrongDetail'),
          meta: {path: '/wrongCollection'}
        },
        {
          path: '/proactiveTest',
          name: 'proactiveTest',
          component: () => import('@/pages/proactiveTest'),
          meta: {path: '/proactiveTest'}
        },
        {
          path: '/proactiveStatistics',
          name: 'proactiveStatistics',
          component: () => import('@/pages/proactiveStatistics'),
          meta: {path: '/proactiveStatistics'}
        },
        {
          path: '/proactiveTestEx',
          name: 'proactiveTestEx',
          component: () => import('@/pages/proactiveTestEx'),
          meta: {path: '/proactiveTest'}
        },
        {
          path: '/proactiveTestDetail',
          name: 'proactiveTestDetail',
          component: () => import('@/pages/proactiveTestDetail'),
          meta: {path: '/proactiveTest'}
        },
        {
          path: '/proactiveTestResult',
          name: 'proactiveTestResult',
          component: () => import('@/pages/proactiveTestResult'),
          meta: {path: '/proactiveTest'}
        },
      ]
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: () => import('@/pages/personalCenter'),
      meta: {path: '/personalCenter'}
    },
  ]
})

router.beforeEach((to, from, next) => {
  process.env.NODE_ENV === 'production' && checkUpdate()
  if (sessionStorage.getItem('smsPending') === '1' && to.name !== 'login' && to.name !== 'register') {
    next({ name: 'login' })
    return
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js